// @flow

import {
  type UserInputValidationError,
  type UserInputValidatorArgs,
  onlyWhenSupport,
  VALID,
} from '@tectonics/prs/validation';

import { validateEcuadorianAddress } from './ecuadorian-address';
import { validateEcuadorianDocument } from './ecuadorian-document';
import { validateEcuadorianPhoneNumber } from './ecuadorian-phone-number';

import { getCurrentFeatures } from '@tectonics/prs/payment-spec';
import { getCurrentPaymentMethodOptionalFields, hasOptionalField } from '@tectonics/prs/incoming-payment/get-payment-type-optional-fields';

export function validator({
  spec,
  prsSupport,
  userInputName,
  userInputValue,
  userInputValues,
  incomingPayment,
}: UserInputValidatorArgs): ?UserInputValidationError {
  const currentFeatures = getCurrentFeatures(spec, userInputValues['selectedPaymentMethod']);
  const onlyWhen = onlyWhenSupport(currentFeatures, prsSupport);
  let optionalFields = incomingPayment.status === 'OP' ? getCurrentPaymentMethodOptionalFields(incomingPayment, userInputValues, spec) : [];

  switch (userInputName) {
    case 'ecuadorianDocument':
      if (!hasOptionalField(optionalFields, 'document')) {
        return onlyWhen('field_ecuadorian_document') && validateEcuadorianDocument(userInputValue);
      }
      return null;

    case 'ecuadorianPhoneNumber':
      if (!hasOptionalField(optionalFields, 'telephone')) {
        return onlyWhen('field_ecuadorian_phone_number') && validateEcuadorianPhoneNumber(userInputValue);
      }
      return null;

    case 'ecuadorianAddress':
      if (!hasOptionalField(optionalFields, 'address')) {
        return onlyWhen('field_ecuadorian_address') && validateEcuadorianAddress(userInputValue);
      }
      return null;

    default:
      return VALID;
  }
}
